var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 17.61C11.24 17.75 11.41 17.84 11.59 17.9C11.72 17.96 11.86 18 12.01 18C12.16 18 12.3 17.96 12.42 17.9C12.6 17.84 12.77 17.75 12.91 17.61L18.16 12.35C18.55 11.96 18.55 11.33 18.16 10.94C17.77 10.55 17.14 10.55 16.75 10.94L13.02 14.69V3.01001C13.02 2.46001 12.58 2.01001 12.02 2.01001C11.46 2.01001 11.02 2.46001 11.02 3.01001V14.69L7.28001 10.95C6.89001 10.56 6.26001 10.56 5.87001 10.95C5.48001 11.34 5.48001 11.97 5.87001 12.36L11.12 17.62L11.1 17.61Z",
    fill: "#009CB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C18.45 18 18 18.45 18 19C18 19.66 17.4 20.01 16.84 20.01H7.14C6.57 20.01 6 19.66 6 19C6 18.45 5.55 18 5 18C4.45 18 4 18.45 4 19C4 20.69 5.38 22.01 7.14 22.01H16.84C18.61 22.01 20 20.69 20 19C20 18.45 19.55 18 19 18Z",
    fill: "#009CB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArr);
export default __webpack_public_path__ + "static/media/downArr.6b31378b4b7b002a5dfe67acf4af33ad.svg";
export { ForwardRef as ReactComponent };